import React, { JSX } from "react";
import { Box } from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import { clientSearchSecondaryLabel } from "../../../models/Client";
import ClientSearch from "../../../components/ClientSearch";
import { t } from "../../../components/translate";
import { Client } from "../../../interfaces/ClientInterface";

const BillingPackageSearch = ({
  selectedClient,
  setSelectedClient
}: {
  selectedClient: Client;
  setSelectedClient: (client: Client | null) => void;
}): JSX.Element => (
  <Box
    sx={{
      mr: 2,
      display: "flex",
      justifyContent: "space-between"
    }}
  >
    <Box sx={{ flexGrow: 1 }} />
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#ececec",
        borderRadius: 1,
        px: 1,
        py: 0.5,
        gap: 1
      }}
    >
      <SearchIcon />
      <Box width="220px">
        <ClientSearch
          autoFocus
          client={selectedClient}
          setClient={setSelectedClient}
          margin="none"
          placeholder="Search by client"
          secondaryText={[
            {
              type: clientSearchSecondaryLabel.CUSTOMER_NUMBER
            },
            {
              type: clientSearchSecondaryLabel.EXTERNAL_IDENTIFIER,
              label: t("client.externalIdentifier.short")
            }
          ]}
        />
      </Box>
    </Box>
  </Box>
);

export default BillingPackageSearch;
